// Status DB per sub-kolom /tagihan — SATU sumber untuk fetch daftar nota per
// sub-kolom, facet (`customer_invoice_facets`, dikunci invoiceFacetsRpc.test),
// direktori admin, dan badge Tagihan di bottom nav.
//
// Modul sendiri, bukan di `@/lib/invoices`: bottom nav tampil di SEMUA halaman
// storefront dan cuma butuh daftar ini, jadi ia tak boleh menyeret modul nota
// yang besar beserta impornya. `@/lib/invoices` mengekspor ulang konstanta ini,
// jadi pemakai lama tak berubah. Impor tipe di bawah terhapus saat kompilasi —
// tak ada siklus impor saat runtime.

import type { InvoiceStatus, InvoiceSubTab } from "@/lib/invoices";

export const INVOICE_SUBTAB_STATUSES: Record<InvoiceSubTab, InvoiceStatus[]> = {
  belum_lunas: ["pending_acc", "open", "partial"],
  sudah_lunas: ["paid"],
  ditolak: ["void", "rejected"]
};
